import React, { useState } from "react";
import { addsubject } from '../api/ApiAtd';

const FillSubject = ({ data, setsesInfo }) => {
  const [subjects, setSubjects] = useState([""]);
  const [showSubSubmitLoad, setSubSubmitLoad] = useState(false);


  // Add a new input field for subjects
  const handleAddSubject = () => {
    setSubjects([...subjects, ""]);
  };

  // Handle input change for a specific subject
  const handleInputChange = (index, value) => {
    const updatedSubjects = [...subjects];
    updatedSubjects[index] = value;
    setSubjects(updatedSubjects);
  };

  // Delete a specific subject input field
  const handleDeleteSubject = (index) => {
    if (subjects.length > 1) {
      const updatedSubjects = subjects.filter((_, i) => i !== index);
      setSubjects(updatedSubjects);
    } else {
      alert("At least one subject is required.");
    }
  };

  // Submit the data to the API
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubSubmitLoad(true);
    try {
      const response = await addsubject(data.sesDet._id, subjects);
      console.log("Data saved successfully:", response.data);
      console.log(response.data)
      setsesInfo(response.data);
      
    } catch (error) {
      console.error("Error saving data:", error);
      alert("An error occurred while saving data.");
    } finally{
      setSubSubmitLoad(false);
    }
  };

  return (
    <div className="container ">
      <h1 className="text-xl font-bold mt-2 mb-5">Add Subjects</h1>
      <form onSubmit={handleSubmit}>
        {subjects.map((subject, index) => (
          <div key={index} className="mb-3 flex items-center">
            <input
            required
              type="text"
              value={subject}
              onChange={(e) => handleInputChange(index, e.target.value)}
              placeholder={`Subject ${index + 1}`}
              className="border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            />
            {subjects.length > 1 && (
              <button
                type="button"
                onClick={() => handleDeleteSubject(index)}
                className="ml-2 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              >
                Delete
              </button>
            )}
          </div>
        ))}
        <div className="flex space-x-3">
          <button
            type="button"
            onClick={handleAddSubject}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Add Subject
          </button>
          <button
          onClick={handleSubmit}
            type="submit"
            className="items-center w-40 text-white bg-blue-500 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
          >
            {showSubSubmitLoad ? (<>
              <div className="flex items-center">
                <div class="w-3 h-3 rounded-full animate-spin
border-2 border-solid border-white border-t-transparent mr-2"></div>
                Submitting...</div>
            </>) : (<>
              Submit
            </>)}

          </button>
        </div>
      </form>
    </div>
  );
};

export default FillSubject;
// FillSubject